<template>
  <div class="dictionary-view">
    <div v-if="dictionary" class="dictionary-container">
      <StaggeredFadeTransition tag="div" :delay="20">
        <details
          v-for="(term, index) in dictionary"
          :key="index"
          :data-index="index"
        >
          <summary>{{ term.dict_text }}</summary>
          <div class="explanation" v-html="term.dict_explanation"></div>
        </details>
      </StaggeredFadeTransition>
    </div>
  </div>
</template>

<script>
import StaggeredFadeTransition from "@/components/StaggeredFadeTransition.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "DictionaryView",
  components: { StaggeredFadeTransition },
  computed: {
    ...mapGetters(["dictionary"]),
  },
  mounted() {
    this.setPageType(this.$route.meta.pageType);
    // see https://stackoverflow.com/a/36994802/1058055
    // Fetch all the details element.
    const details = document.querySelectorAll("details");

    // Add the onclick listeners.
    details.forEach((targetDetail) => {
      targetDetail.addEventListener("click", () => {
        // Close all the details that are not targetDetail.
        details.forEach((detail) => {
          if (detail !== targetDetail) {
            detail.removeAttribute("open");
          }
        });
      });
    });
  },
  methods: {
    ...mapActions(["setPageType"]),
  },
};
</script>

<style lang="scss" scoped>
.dictionary-view {
}
</style>
